module.exports = __webpack_public_path__ + "img/ctrl-circuit-stub-down-+.e44a1291.svg";